import { intl } from '../../utils/intl';
const t = (id) => intl.formatMessage({ id });

export default {
  categories: [
    {
      label: "Space Overview",
      viewModeLabel: "Space Overview",
      id: "Space_Overview",
      sections: [
        {
          label: '',
          excludeKeysViewMode: [
            'basic_info.integrations'
          ],
          keys: [
            'basic_info.mezannine_area',
            'basic_info.year_built',
            'basic_info.site_size',
            'basic_info.zoning',
            'basic_info.has_stepdown_transformer',
            'basic_info.tear_sheet',
            'basic_info.size',
            'basic_info.measured_width_of_space',
            'basic_info.measured_depth_of_space',
            'basic_info.joist_direction'
          ],
          subsections: []
        },
        {
          label: t('assetSchema.headers.thickness'),
          keys: [
            'basic_info.thickness.front_wall',
            'basic_info.thickness.rear_wall',
            'basic_info.thickness.left_wall',
            'basic_info.thickness.right_wall'
          ],
          subsections: []
        },
        {
          label: t('assetSchema.headers.ceiling_information'),
          keys: [],
          subsections: [
            {
              label: 'Height from Floor to Ceiling',
              compound: true,
              keys: [
                'basic_info.ceiling_information.height_from_floor_to_ceiling.front',
                'basic_info.ceiling_information.height_from_floor_to_ceiling.back',
                'basic_info.ceiling_information.height_from_floor_to_ceiling.center'
              ]
            },
            {
              label: 'Height from Floor to Bottom of Deck',
              compound: true,
              keys: [
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_deck.front',
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_deck.back',
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_deck.center'
              ]
            },
            {
              label: 'Height from Floor to Bottom of Joist',
              compound: true,
              keys: [
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_joist.front',
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_joist.back',
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_joist.center'
              ]
            },
            {
              label: 'Height from Floor to Bottom of Girder - Only for Spaces Over 10K Reported Sq Ft',
              compound: true,
              keys: [
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_girder.left_front',
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_girder.right_front',
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_girder.left_rear',
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_girder.right_rear',
                'basic_info.ceiling_information.height_from_floor_to_bottom_of_girder.middle'
              ]
            },
            {
              label: t('assetSchema.clear_height'),
              keys: [
                'basic_info.ceiling_information.clear_height'
              ]
            },
            {
              label: 'Clear Ceiling Height',
              keys: [
                'basic_info.ceiling_information.clear_ceiling_height'
              ]
            },
            {
              label: t('assetSchema.clear_height_floor_to_deck'),
              keys: [
                'basic_info.ceiling_information.clear_height_floor_to_deck'
              ]
            },
            {
              label: 'Clear Height (At Column)',
              keys: [
                'basic_info.ceiling_information.clear_height_floor_front_column',
                'basic_info.ceiling_information.clear_height_floor_mid_column',
                'basic_info.ceiling_information.clear_height_floor_rear_column'
              ]
            },
            {
              label: t('assetSchema.clear_height_floor_to_lowest_obstruction'),
              keys: [
                'basic_info.ceiling_information.clear_height_floor_to_lowest_obstruction'
              ]
            }
          ]
        },
        {
          label: t('assetSchema.headers.construction_overview'),
          keys: [
            'basic_info.construction_overview.structure',
            'basic_info.construction_overview.roof_type',
            'basic_info.construction_overview.roof_warranty_expiration',
            'basic_info.construction_overview.warehouse_lighting_type',
            'basic_info.construction_overview.office_lighting_type',
            'basic_info.construction_overview.sprinkler_head_type',
            'basic_info.construction_overview.warehouse_sprinkler_head_type',
            'basic_info.construction_overview.office_sprinkler_head_type',
            'basic_info.construction_overview.sprinkler_system',
            'basic_info.property_features.utility_submetered'
          ],
          subsections: []
        },
        {
          label: t('assetSchema.headers.property_features'),
          keys: [
            'basic_info.property_features.building_dimensions',
            'basic_info.property_features.space_dimensions_width',
            'basic_info.property_features.space_dimensions_length',
            'basic_info.property_features.column_bay_spacing',
            'basic_info.property_features.column_bay_spacing_depth',
            'basic_info.property_features.speed_bays',
            'basic_info.property_features.truck_court_depth',
            'basic_info.property_features.truck_apron',
            'basic_info.property_features.loading',
            'basic_info.property_features.floor_load',
            'basic_info.property_features.num_of_trailer_parking_spots',
            'basic_info.property_features.dock_doors',
            'basic_info.property_features.drive_in_doors',
            'basic_info.property_features.railway_dock_doors',
            'basic_info.property_features.car_parking',
            'basic_info.property_features.hvac',
            'basic_info.property_features.interior_dock_leveler_type',
            'basic_info.property_features.interior_dock_leveler_width',
            'basic_info.property_features.interior_dock_leveler_height',
            'basic_info.property_features.dock_leveler_length'
          ],
          subsections: []
        },
        {
          label: t('assetSchema.headers.other'),
          width: '32%',
          keys: [
            'basic_info.cooler_manufacturer',
            'basic_info.lockbox_used_to_access_the_space',
            'basic_info.exterior_ladder_used_to_access_the_roof',
            'basic_info.roof_too_unsafe_to_access',
            'basic_info.roof_hatch_used_to_access_the_roof',
            'basic_info.misc_notes'
          ],
          subsections: []
        },
        {
          label: t('assetSchema.headers.integrations'),
          excludeKeysViewMode: [
            'basic_info.integrations.integration_property_id',
            'basic_info.integrations.idp_record_id'
          ],
          keys: [
            'basic_info.integrations.integration_property_id',
            'basic_info.integrations.idp_record_id'
          ],
          subsections: []
        }
      ]
    },
    {
      label: "Flooring",
      viewModeLabel: "Space Overview",
      id: "Space_Overview",
      hideCategoryLabel: true,
      sections: [
        {
          label: '',
          excludeKeysViewMode: [
            'basic_info.separate_rpm_renders',
            'basic_info.virtual_tour_link',
            'basic_info.white_box_link'
          ],
          keys: [
            'basic_info.separate_rpm_renders',
            'basic_info.virtual_tour_link',
            'basic_info.tax_pin',
            'basic_info.overall_actual_sq_ft',
            'basic_info.white_box_link',
            'basic_info.total_depth_of_space'
          ],
          subsections: []
        },
        {
          label: t('assetSchema.headers.unit_overview'),
          width: '32%',
          keys: [
            'basic_info.unit_overview.sales_area',
            'basic_info.unit_overview.stock_room',
            'basic_info.unit_overview.exterior_doors',
            'basic_info.unit_overview.other'
          ],
          subsections: []
        },
        {
          label: t('assetSchema.headers.flooring'),
          width: '32%',
          keys: [
            'basic_info.flooring_square_footage.concrete',
            'basic_info.flooring_square_footage.tile',
            'basic_info.flooring_square_footage.other',
            'basic_info.flooring_square_footage.carpet',
            'basic_info.flooring_square_footage.total',
            'basic_info.flooring_square_footage.unit',
            'basic_info.flooring_square_footage.type_of_other'
          ],
          subsections: []
        }
      ]
    },
    {
      label: "Special Scopes",
      viewModeLabel: "Space Overview",
      id: "Space_Overview",
      hideCategoryLabel: true,
      sections: [
        {
          label: '',
          keys: [
            'basic_info.property_features.power',
            'basic_info.property_features.storefront_width',
            'basic_info.property_features.storefront_features',
            'basic_info.ceiling_information.number_of_acoustical_tiles',
            'basic_info.property_features.damaged_stained_missing_acoustical_tiles',
            'basic_info.hazardous_materials',
            'basic_info.changes_in_demising_wall_thickness',
            'basic_info.which_demising_wall_changes',
            'basic_info.difference_demising_wall_thickness',
            'basic_info.property_features.ceiling_types',
            'basic_info.property_features.wall_types',
            'basic_info.property_features.exterior_door_count',
            'basic_info.property_features.exterior_door_dimensions',
            'basic_info.property_features.exterior_door_locations',
            'basic_info.property_features.light_fixture_count',
            'basic_info.property_features.hydraulic_sprinkler',
            'basic_info.property_features.type_of_fixture',
            'basic_info.loading_dock',
            'basic_info.storefront_slope_measurement',
            'basic_info.storefront_slope_direction',
            'basic_info.riser_room_scanned_captured',
            'basic_info.property_features.type_of_lighting',
            'basic_info.property_features.access_interior_area',
            'basic_info.thermostat_count',
            'basic_info.thermostat_location',
            'basic_info.phone_board_count',
            'basic_info.phone_board_location',
            'basic_info.sanitary_sewer_count',
            'basic_info.sanitary_sewer_location',
            'basic_info.mop_sink_count',
            'basic_info.mop_sink_location',
            'basic_info.property_features.floor_drain_count',
            'basic_info.property_features.floor_drain_location',
            'basic_info.cleanout_count',
            'basic_info.cleanout_location',
            'basic_info.pad_mounted_transformer_count',
            'basic_info.pad_mounted_transformer_location',
            'basic_info.property_features.exterior_transformer',
            'basic_info.property_features.meter_room_space',
            'basic_info.property_features.exterior_access_rooms',
            'basic_info.property_features.exterior_partition_extrusion',
            'basic_info.electric_meter_distance',
            'basic_info.gas_meter_distance',
            'basic_info.water_meter_distance',
            'basic_info.transformer_distance',
            'basic_info.sewer_cleanout_distance',
            'basic_info.utility_room_distance',
            'basic_info.DMARC_distance',
            'basic_info.exterior_wall_photograph',
            'basic_info.storefront_scan_width',
            'basic_info.roof_capture_hvac',
            'basic_info.roof_plan_complete',
            'basic_info.projector_photograph',
            'basic_info.window_pane_type',
            'basic_info.are_demising_walls_full_height',
            'basic_info.are_interior_walls_full_height'
            
          ],
          subsections: [
            {
              label: t('assetSchema.headers.outer_unit_corner_to_outer_block_corner'),
              keys: [
                'basic_info.outer_unit_corner_to_outer_block_corner.left',
                'basic_info.outer_unit_corner_to_outer_block_corner.right'
              ]
            },
            {
              label: t('assetSchema.headers.height_from_floor_to_bottom_of_girder_kite'),
              keys: [
                'basic_info.height_from_floor_to_bottom_of_girder_kite.left_front',
                'basic_info.height_from_floor_to_bottom_of_girder_kite.right_rear'
              ]
            }
          ]
        }
      ]
    }
  ]
}
